<script setup>
import {
  ref,
  onMounted,
  getCurrentInstance,
  watch,
  computed,
  defineProps,
  defineEmits
} from 'vue';
import { useStore } from 'vuex';
import commonFn from '@/commons/commonFunction';
import MsToolTip from '@/components/tooltip/MsToolTip.vue';
import { useRoute } from 'vue-router';
import debtInvoiceAPI from '@/apis/eTask/debtInvoiceAPI';

const props = defineProps({
  isShowDebtInvoicePopup: {
    type: Boolean,
    default: false,
  },

  debtInvoices: {
    type: Array,
    default: () => [],
  },
});

const emits = defineEmits(['onClose']);

const { proxy } = getCurrentInstance();
const store = useStore();
const route = useRoute();
const textNotifyOrg = computed(() => {
  return (
    store.state.context.User.OrganizationUnitName +
    ` (MQHNS: ${store.state.context.User.OrganizationUnitCode})`
  );
});

/**
 * Bắt sự kiện click tắt thông báo
 */
const closeToast = () => {
  emits('onClose');
};

/**
 * Bắt sự kiện khi click xem chi tiết hóa đơn
 */
const clickPreviewInvoice = async (item) => {

  window.open(
    `${window.meinvoiceLink}tra-cuu/?sc=${item.TransactionID}`,
    '_blank'
  );
};
</script>

<template>
  <transition name="toast-msg-notify">
    <div v-if="isShowDebtInvoicePopup" class="ms-toast-msg-notify flex-row">
      <div class="icon-debt-invoice"></div>
      <div class="flex flex-column">
        <div class="text-header">Thông báo nhắc nợ thanh toán</div>
        <div>
          <div>Kính gửi: Quý đơn vị!</div>
          <div class="text-content">
            Công ty cổ phần MISA đã xuất hóa đơn cho {{ textNotifyOrg }}. Quý
            đơn vị vui lòng làm thủ tục thanh toán để không bị gián đoạn công
            việc. <br />
            Mọi thủ tục vướng mắc về thanh toán Quý đơn vị liên hệ Tel:
            090476393; Email: accounting@han.misa.com.vn
          </div>

          <div class="invoice-item" v-for="(item, index) in debtInvoices">
            <div>
              Hóa đơn số {{ item.InvTemplateNo }} xem hóa đơn
              <span class="link-cls" @click="clickPreviewInvoice(item)">tại đây</span>
            </div>
          </div>
          <div class="item-content">
            Nếu Quý đơn vị đã thanh toán vui lòng bỏ qua thông báo này.
          </div>
        </div>
      </div>
      <div
        v-tooltip="$t('i18nCommon.command.close')"
        class="icon-close pointer"
        @click.prevent.stop="closeToast"
      >
        <div class="icon20 ic_close-grey-16" />
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
.content-tooltip {
  max-width: 600px;
}
.icon-close {
  position: absolute;
  right: 14px;
  top: 12px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: var(--grey-10);
    border-radius: 50%;
  }
}

.ms-toast-msg-notify {
  position: fixed;
  bottom: 7px;
  right: 24px;
  background-color: #fff;
  border-radius: 6px;
  border-left: 8px solid #fce5d9;
  box-shadow: 0 0 10px 0 rgba($color: #000000, $alpha: 0.18);
  padding: 16px 16px 16px 0px;
  display: flex;
  min-height: 114px;
  width: 460px;
  z-index: 9999;

  .text-header {
    color: #f07d42;
    margin-bottom: 10px;
  }
  .text-content {
    width: 97%;
    padding-bottom: 8px;
  }
  .invoice-item {
    padding-top: 8px;
    .link-cls {
      color: #4262f0;
      text-decoration: underline;
    }
    .link-cls:hover {
      cursor: pointer !important;
    }
  }
  .item-content {
    padding-top: 16px;
  }

  .icon-debt-invoice {
    background-repeat: no-repeat;
    background-image: url($ms-image-ic_debt_invoice);
    width: 150px;
    min-height: 114px;
    background-position: 17px 2px;
  }

  .ms-toast-msg-notify__close-btn {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 24px !important;
    height: 24px !important;
  }

  .avatar {
    position: relative;
    object-fit: cover;
    margin-right: 12px;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    img:nth-child(1) {
      min-height: 40px;
      min-width: 40px;
      height: 40px;
      width: 40px;
      border-radius: 50%;
    }
    .icon-type {
      position: absolute;
      right: -2px;
      bottom: -3px;
    }
  }
  .content {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    word-break: break-word;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .time {
    line-height: 12px;
    font-size: 12px;
    margin: 4px 0;
  }
}

.toast-msg-notify-enter-active,
.toast-msg-notify-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.toast-msg-notify-enter {
  opacity: 0;
  transform: translateX(100%);
}
.toast-msg-notify-leave-to {
  opacity: 0;
}
</style>
